import React from "react";
import PageWrapper from "./form.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import FormTable from "../../components/form/FormTable";

const FormManagement = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.formManagement"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.formManagement"
          }
        ]}
      />
      <div className="user-tbl">
        <FormTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.permissionReducer,
    ...state.themeChanger,
    ...state.auth
  };
};

export default connect(mapStateToProps, null)(FormManagement);
